module.exports = __webpack_public_path__ + "static/media/Madhv.c2d80ee8.png";